import {Slider as MantineSlider, SliderProps as MantineSliderProps} from "@mantine/core";

export type SliderProps = MantineSliderProps

export type SliderMarkProps = Pick<SliderProps, 'marks'>

export const Slider = (props: SliderProps) => {
    const {...rest} = props;
    return <MantineSlider {...rest} />;
};
